<template>
  <div>
    <v-card elevation="1">
      <v-card-text>
        <h3>Orden de compra</h3>
        <v-divider />
        <v-form ref="formPresentacion">
          <v-row class="mt-2">
            <v-col md="2">
              <v-autocomplete
                label="Almacén"
                v-model="OrdenCompra.amc"
                :rules="rules.Requerido"
                :items="origenes"
                item-text="Nombre"
                item-value="id"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="2">
              <v-autocomplete
                label="Departamento"
                v-model="OrdenCompra.dpt"
                :rules="rules.Requerido"
                :items="modulos"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="4">
              <v-autocomplete
                label="Estatus"
                v-model="OrdenCompra.sts"
                :rules="rules.Requerido"
                :items="estatusList"
                item-text="name"
                item-value="id"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="12" cols="12">
              <div class="text-right">
                <!-- <v-btn
                  elevation="0"
                  class="mx-1"
                  v-if="OrdenCompra.amc"
                  @click="openImportador()"
                  small
                  >Importar desde existencias deseadas</v-btn
                > -->
                <v-btn
                  elevation="0"
                  class="mx-1"
                  small
                  @click="$emit('toggle', false)"
                  >Cerrar</v-btn
                >
                <v-btn
                  elevation="0"
                  class="mx-1"
                  small
                  color="green"
                  dark
                  @click="saveOrdenCompra()"
                  >Guardar Orden</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="my-2" />
        <v-row class="mt-2">
          <v-col md="4">
            <h4>Agregar productos</h4>
            <v-form ref="formProdAdd">
              <v-autocomplete
                label="Producto"
                :rules="rules.Requerido"
                v-model="reqToAdd.prd"
                :items="global_prod"
                item-text="Nombre"
                item-value="id"
              >
              </v-autocomplete>
              <v-text-field
                v-model="reqToAdd.cnt"
                :rules="rules.Requerido"
                @keypress="$pgsHelper.onlyNumber($event, reqToAdd.cnt)"
                :label="'Cantidad (' + unidadMedida + ')'"
              >
              </v-text-field>
            </v-form>
            <v-btn block color="green" @click="addProd()" outlined dark
              >Agregar Producto</v-btn
            >
          </v-col>
          <v-col md="8" v-if="OrdenCompra.req">
            <h4>Requerimientos</h4>
            <v-btn small @click="deleteInsumo()" outlined color="red"
              ><v-icon>mdi-delete</v-icon> Eliminar productos</v-btn
            >
            <ag-grid-vue
              v-if="OrdenCompra.req.length > 0"
              style="height: 300px"
              class="ag-theme-alpine"
              :columnDefs="columnDefs"
              rowSelection="single"
              :rowData="OrdenCompra.req"
              @gridReady="ongridReady($event)"
              @selection-changed="onSelectionChanged($event)"
            >
            </ag-grid-vue>
            <v-alert
              elevation="0"
              class="mt-2"
              v-if="OrdenCompra.req.length == 0"
              border="bottom"
              colored-border
              type="info"
            >
              La orden de compra esta vacia.
            </v-alert>
          </v-col>
        </v-row>

        <v-divider />
      </v-card-text>
    </v-card>

    <!-- <modal
      v-model="importadorToogle"
      persistent
      :fullscreen="true"
      :title="'Importar desde existencias deseadas'"
    >
      <ImportarExistenciasForm
        :importador="importador"
        :ordenCompra="OrdenCompra"
        @importar="importar"
      >
      </ImportarExistenciasForm>
    </modal>
     <v-dialog class="importModal" v-model="importadorToogle">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Importar desde existencias deseadas
        </v-card-title>

        <v-card-text> 
          Selecciona los almacenes desde donde deseas validar las existencias
          deseadas
          <v-select label="Almacén" v-model="importador.Almacenes" :rules="rules.Requerido" multiple :items="origenes"
            item-text="Nombre" item-value="id">
          </v-select>
          <v-btn @click="verifyExistencias()" block class="my-2" color="primary" outlined>
            Consultar Existencias
          </v-btn>
          <v-expansion-panels elevation="0">
            <v-expansion-panel elevation="0">
              <v-expansion-panel-header>
                <b>{{ totalToImport }} de {{ (this.ProductsToImport) ? this.ProductsToImport.length : 0 }} Productos presentan
                  baja existencia </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p>
                  todos los datos mostrados estan basados en los almacenes
                  seleccionados anteriormente y en el almacen de la orden de
                  compra
                </p>
                <v-simple-table fixed-header height="300px">
                  <thead>
                    <tr>
                      <th width="10">Producto</th>
                      <th width3="10" class="text-center">Existencia</th>
                      <th width="10" class="text-center">Otros almacenes</th>
                      <th width="10" class="text-center">Existencia Total</th>
                      <th width="10" class="text-center">Estatus</th>
                      <th width="50" class="text-center">
                        <v-row>
                          <v-col cols="4"><v-btn @click="selectAllIdeal(1)" x-small color="primary">Ideal
                              Almacen</v-btn></v-col>
                          <v-col cols="4" v-if="showTotalAlmacen"><v-btn @click="selectAllIdeal(2)" x-small
                              color="primary">Ideal Total</v-btn></v-col>
                          <v-col cols="4" v-if="showTotalCalculado"><v-btn @click="selectAllIdeal(3)" x-small
                              color="primary">Ideal Calculado</v-btn></v-col>
                        </v-row>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(prod, index) in computedProductosToImport" :key="index">
                     
                      <td>{{ prod.Nombre }}</td>


                      <td class="text-center">
                        <div>
                          <span class="text-caption">Min: {{ prod.existAlert.emin }} ||</span>
                          <span class="text-caption">
                            Ideal: {{ prod.existAlert.eidl }}</span>
                        </div>
                        <b v-bind:class="prod.Stock < prod.existAlert.emin ? 'red--text' : ''
                          ">{{ $pgsHelper.formatNumber(prod.Stock) }} {{ prod.UM }}</b>
                      </td>

                      
                      <td>
                        <div v-for="(almacen, index) in prod.AlmacenComparacion" :key="index">
                          <span>&#8226;</span> {{ almacen.Nombre }} :
                          {{ $pgsHelper.formatNumber(almacen.Stock) }}
                        </div>
                      </td>


                      <td class="text-center">
                        <div>
                          <span class="text-caption">Min: {{ prod.existAlertTotal.emin }} ||</span>
                          <span class="text-caption">
                            Ideal: {{ prod.existAlertTotal.eidl }}</span>
                        </div>
                        <b v-bind:class="prod.ExistenciaTotal < prod.existAlertTotal.emin
                            ? 'red--text'
                            : ''
                          ">{{
                            $pgsHelper.formatNumber(prod.ExistenciaTotal)
                          }}</b>
                      </td>


                      <td class="text-center">
                        <v-btn v-if="prod.askToImport && !prod.availableToImport" block color="success" x-small
                          elevation @click="
                            ProductsToImport[index].availableToImport = true;
                          refresh++;
                          ">Importar</v-btn>
                        <v-btn v-if="prod.askToImport && prod.availableToImport" block color="error" x-small elevation
                          @click="
                            ProductsToImport[index].availableToImport = false;
                          refresh++;
                          ">No Importar</v-btn>
                        <b v-if="prod.availableToImport" class="primary--text">Se solicitara
                          {{ $pgsHelper.formatNumber(ProductsToImport[index].cantToRequest) }}</b>
                        <b class="green--text" v-if="!prod.availableToImport & !prod.askToImport">Existencia
                          suficiente</b>
                      </td>


                      <td class="text-center">
                        <v-radio-group v-model="ProductsToImport[index].cantToRequest" :key="refresh">
                          <v-row>
                            <v-col>
                              <v-radio :label="$pgsHelper.formatNumber(prod.cantToRequestByAlmacen)"
                                :value="prod.cantToRequestByAlmacen" @click="
                                  setCantToRequest(
                                    index,
                                    prod.cantToRequestByAlmacen
                                  )
                                  "></v-radio>
                            </v-col>
                            <v-col v-if="showTotalAlmacen"><v-radio
                                :label="$pgsHelper.formatNumber(prod.cantToRequestByTotal)"
                                :value="prod.cantToRequestByTotal" @click="
                                  setCantToRequest(
                                    index,
                                    prod.cantToRequestByTotal
                                  )
                                  "></v-radio></v-col>
                            <v-col v-if="showTotalCalculado"><v-radio
                                :label="$pgsHelper.formatNumber(prod.cantCalulated)" :value="prod.cantCalulated" @click="
                                  setCantToRequest(index, prod.cantCalulated)
                                  "></v-radio>
                              <b class="text-caption">IC: {{ $pgsHelper.formatNumber(prod.eidl) }}</b>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </td>


                    </tr>
                  </tbody>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="
            importadorToogle = false;
          ProductsToImport = [];
          " color="red" text>
            Cancelar
          </v-btn>
          <v-btn @click="importar()" color="primary" text>
            Importar
          </v-btn>
        </v-card-actions>
      </v-card> 


    </v-dialog>
    -->
  </div>
</template>

<script>
import OrdenCompra from "../../../clases/Inventarios/OrdenesCompra.js";
import { mapGetters } from "vuex";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
import { min } from "lodash";
// import modal from "../../MainComponents/modal.vue";
// import ImportarExistenciasForm from "./ImportarExistenciasForm.vue";

export default {
  name: "OrdenCompraForm",
  components: {
    AgGridVue,
    //  ImportarExistenciasForm
  },
  props: ["edit", "dataEdit", "modal"],
  data() {
    return {
      refresh: 0,
      importadorToogle: false,
      origenes: [],
      estatusList: OrdenCompra.getStatusList(),
      OrdenCompra: OrdenCompra.getPropertyModel(),
      rules: OrdenCompra.getRules(),
      showTotalCalculado: true,
      columnDefs: null,
      reqToAdd: {
        prd: null,
        nom: "",
        cnt: 1,
      },
      selection: [],
      importador: {
        Almacenes: [],
        ExistenciasSelectedaAlmacen: [],
      },
      ProductsToImport: [],
      /*presentacion: PresentacionesAYB.getPropertyModel(),
      presentaciones:[],
      rules:PresentacionesAYB.getRules(),
      Proveedores:[],*/
    };
  },
  methods: {
    resetForm() {
      this.reqToAdd = {
        prd: null,
        nom: "",
        cnt: 1,
      };
    },
    setCantToRequest(index, cant) {
      this.ProductsToImport[index].cantToRequest = Number(cant);
      this.refresh++;
    },
    selectAllIdeal(option) {
      this.ProductsToImport.forEach((prod) => {
        if (option == 1) {
          prod.cantToRequest = Number(prod.cantToRequestByAlmacen);
        } else if (option == 2) {
          prod.cantToRequest = Number(prod.cantToRequestByTotal);
        } else {
          prod.cantToRequest = Number(prod.cantCalulated);
        }
      });
      this.refresh++;
    },
    // openImportador() {
    //   this.importador.Almacenes = [this.OrdenCompra.amc];
    //   this.importadorToogle = true;
    // },
    // importar() {
    //   this.ProductsToImport.forEach((prod) => {
    //     let data = {
    //       prd: prod.id,
    //       nom: prod.Nombre,
    //       cnt: this.$pgsHelper.roundDecimals(prod.cantToRequest),
    //     };
    //     if (Number(prod.cantToRequest) > 0) {
    //       this.OrdenCompra.req.push(this.$pgsHelper.cloneObj(data));
    //     }
    //   });
    //   this.importadorToogle = false;
    // },
    // verifyExistencias() {
    //   this.ProductsToImport = [];
    //   let origenes = this.$store.getters.getOrigenes;
    //   let productosGlobales = this.$store.getters.getProductos;
    //   /* Se selecciona existencias en el almacen seleccionado en la orden de compra */
    //   this.importador.ExistenciasSelectedAlmacen = origenes.filter(
    //     (origen) => origen.Origen == this.OrdenCompra.amc
    //   );
    //   /* Se selecciona existencias de los almacenes a comparar */
    //   let documentosAplicables = origenes.filter(
    //     (origen) =>
    //       this.importador.Almacenes.includes(origen.Origen) &
    //       (origen.Origen != this.OrdenCompra.amc)
    //   );

    //   /* Se adjuntan los productos del almacen principal */
    //   this.importador.ExistenciasSelectedAlmacen.forEach((document) => {
    //     let productos = Object.entries(document.Productos);
    //     productos.forEach((prod) => {
    //       let productData = this.$pgsHelper.getById(
    //         productosGlobales,
    //         "id",
    //         prod[0]
    //       );
    //       // Limitar solo con alerta o todos
    //       let existAlert = { eidl: 0 };
    //       if (productData.amcs) {
    //         existAlert = productData.amcs[this.OrdenCompra.amc];
    //         console.log(existAlert);
    //       }
    //       this.$pgsHelper.forceReactivity(productData.amc);
    //       this.$pgsHelper.forceReactivity(this.OrdenCompra.amc);
    //       if (existAlert) {
    //         this.ProductsToImport.push({
    //           id: prod[0],
    //           ...prod[1],
    //           eidl: productData.eidl ? productData.eidl : 0,
    //           UM: productData.Extra?.AYB?.UM
    //             ? productData.Extra?.AYB?.UM
    //             : "PZ",
    //           existAlert: this.$pgsHelper.cloneObj(existAlert),
    //           existAlertTotal: this.$pgsHelper.cloneObj(existAlert),
    //           Nombre: productData?.Nombre,
    //           AlmacenComparacion: {},
    //           ExistenciaTotal: Number(prod[1].Stock),
    //         });
    //       }
    //     });
    //   });
    //   /* Se adjuntan las existencias de los almacenes a comparar */
    //   documentosAplicables.forEach((document) => {
    //     let productos = Object.entries(document.Productos);
    //     productos.forEach((prod) => {
    //       let productExist = this.$pgsHelper.getById(
    //         this.ProductsToImport,
    //         "id",
    //         prod[0]
    //       );
    //       if (productExist) {
    //         let productData = this.$pgsHelper.getById(
    //           productosGlobales,
    //           "id",
    //           prod[0]
    //         );
    //         let origenData = this.$pgsHelper.getById(
    //           this.origenes,
    //           "id",
    //           document.Origen
    //         );

    //         if (productData.amcs) {
    //           this.ProductsToImport[productExist.idx].existAlertTotal.emin +=
    //             productData.amcs[document.Origen]
    //               ? Number(productData.amcs[document.Origen].emin)
    //               : 0;
    //           this.ProductsToImport[productExist.idx].existAlertTotal.eidl +=
    //             productData.amcs[document.Origen]
    //               ? Number(productData.amcs[document.Origen].eidl)
    //               : 0;
    //         } else {
    //           if (productData.amcs) {
    //             this.ProductsToImport[productExist.idx].existAlertTotal.eidl +=
    //               productData.amcs[document.Origen]
    //                 ? Number(productData.amcs[document.Origen].eidl)
    //                 : 0;
    //           }
    //         }
    //         this.ProductsToImport[productExist.idx].AlmacenComparacion[
    //           document.Origen
    //         ] = { ...prod[1], Nombre: origenData.Nombre };
    //         this.ProductsToImport[productExist.idx].ExistenciaTotal += Number(
    //           prod[1].Stock
    //         );
    //       }
    //     });
    //   });

    //   this.ProductsToImport.forEach((prod) => {
    //     console.log(prod);
    //     let availableToImport = false;
    //     let askToImport = false;
    //     let cantToRequestByAlmacen = 0;
    //     let cantToRequestTotal = 0;
    //     if (prod.Stock < prod.existAlert.emin) {
    //       if (prod.ExistenciaTotal >= prod.existAlertTotal.emin) {
    //         askToImport = true;
    //       } else {
    //         availableToImport = true;
    //       }

    //       cantToRequestByAlmacen = prod.existAlert.eidl - prod.Stock;
    //       cantToRequestTotal = prod.existAlertTotal.eidl - prod.ExistenciaTotal;
    //     }
    //     prod.askToImport = askToImport;
    //     prod.cantToRequestByAlmacen = cantToRequestByAlmacen;
    //     prod.cantToRequestByTotal = cantToRequestTotal;
    //     prod.cantCalulated =
    //       Number(prod.eidl) - prod.Stock <= 0
    //         ? 0
    //         : Number(prod.eidl) - prod.Stock;
    //     prod.cantToRequest = cantToRequestByAlmacen;
    //     prod.availableToImport = availableToImport;
    //   });

    //   this.ProductsToImport = this.ProductsToImport.sort(function (a, b) {
    //     return (
    //       b.askToImport - a.askToImport ||
    //       b.availableToImport - a.availableToImport
    //     );
    //   });
    //   this.refresh++;
    //   this.$forceUpdate();
    //   this.selectAllIdeal(1);
    // },
    deleteInsumo() {
      this.selection.forEach((selectProd) => {
        let prod = this.$pgsHelper.getById(
          this.OrdenCompra.req,
          "prd",
          selectProd.prd
        );
        if (prod) {
          this.OrdenCompra.req.splice(prod.idx, 1);
        }
      });
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();
      this.selection = selectedRows;
    },
    ongridReady: function (params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    addProd() {
      if (this.$refs.formProdAdd.validate()) {
        let prod = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          this.reqToAdd.prd
        );
        this.reqToAdd.nom = prod.Nombre;
        this.OrdenCompra.req.push(this.$pgsHelper.cloneObj(this.reqToAdd));
        this.resetForm();
      }
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    saveOrdenCompra() {
      if (this.$refs.formPresentacion.validate()) {
        this.OrdenCompra.req.forEach((prod) => {
          prod.cnt = Number(prod.cnt);
        });
        this.OrdenCompra.mmt = new moment().format("YYYY-MM-DD_HH:mm:ss");
        let datos = this.OrdenCompra;
        this.$alert.alertConfirm({
          action: this.edit ? "editar" : "agregar",
          obj: "la orden de compra",
          route: this.edit
            ? //? "AMC-Compras-updateCompra"
              //: "AMC-Compras-createCompra",
              "AMC-OrdenesCompra-updateOrdenCompra"
            : "AMC-OrdenesCompra-createOrdenCompra",
          data: datos,
          onSuccess: () => {
            //this.getPresentacionesByProduct()
            this.$emit("successData");
          },
        });
      }
    },
  },
  computed: {
    showTotalAlmacen() {
      let totalAlmacenes = this.importador.Almacenes.length;
      if (totalAlmacenes > 1) {
        return true;
      } else {
        return false;
      }
    },
    // totalToImport() {
    //   let totalImport = this.ProductsToImport.filter(
    //     (prod) => prod.availableToImport == true
    //   );

    //   return totalImport.length;
    // },
    // computedProductosToImport() {
    //   this.$pgsHelper.forceReactivity(this.refresh);
    //   return this.ProductsToImport;
    // },
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    unidadMedida() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.reqToAdd.prd
      );
      if (prod) {
        return prod?.Extra?.AYB?.UM || "PZ";
      }
      return "";
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        if (element.Tipo == "AYB-Insumo" && !element.Dlat) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
  },
  watch: {},
  beforeMount() {
    this.columnDefs = [{ field: "nom" }, { field: "cnt", editable: true }];
    this.getOrigenes();
    if (this.edit) {
      this.OrdenCompra = new OrdenCompra(this.dataEdit);
    } else {
      this.OrdenCompra = new OrdenCompra();
    }
  },
};
</script>
<style>
/* .importModal {
  width: 70vw;
} */
</style>
